import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConvertRegistrationService {
  constructor(private http: HttpClient) {}

  convertEndpoint(): Observable<any> {
    return this.http.post(`secure/full-registration`, null);
  }
}
